import { Component, OnInit } from '@angular/core';
import { indexarFormulasContextos } from '@shared/components/formula/utils/formula-contexto.util';
import { coletarCiclosEmpresa, registrarCicloEmpresa } from '@shared/components/formula/utils/formula-estados.util';
import { FormulaCicloDialogComponent, FormulaCicloDialogData, FormulaCicloDialogResult } from '@shared/components/formula/formula-ciclo-dialog/formula-ciclo-dialog.component';
import { FormulaErrorCodeEnum } from '@shared/enums/formula/formula-error-code.enum';
import { TipoEntidadeFormulaEnum } from '@shared/enums/formula/tipo-entidade-formula.enum';
import { FormulaCicloEmpresaRascunho } from '@shared/services/structs/formula/formula-ciclo-empresa-rascunho.struct';
import { NaturezaOperacaoSalvarResponse } from '@shared/services/responses/motor-fiscal/natureza-operacao-salvar.response';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, forkJoin, of } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { TipoOperacaoEnum } from '@shared/enums/motor-fiscal/tipo-operacao.enum';
import { TipoPadraoNaturezaEnum } from '@shared/enums/motor-fiscal/tipo-padrao-natureza.enum';
import { TipoPadraoNaturezaOperacaoStruct } from '@shared/services/structs/motor-fiscal/tipo-padrao-natureza-operacao.struct';
import { RegimeTributarioEnum } from '@shared/enums/motor-fiscal/regime-tributario.enum';
import { FinalidadeNFeEnum } from '@shared/enums/motor-fiscal/finalidade-nfe.enum';
import { validarCfopPorTipo } from '@shared/validators/cfop-tipo-operacao.validator';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { NaturezaOperacaoService } from '@shared/services/apis/motor-fiscal/natureza-operacao.service';
import { MotorFiscalLookupService } from '@shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { FormulaCatalogoService } from '@shared/services/apis/motor-fiscal/formula-catalogo.service';
import { EmissorService } from '@shared/services/apis/dfe/emissor.service';
import { ModeloDocumentoEnum } from '@shared/enums/dfe/modelo-documento.enum';
import { EmissorElegivelStruct } from '@shared/services/structs/dfe/emissor-elegivel.struct';
import { NaturezaOperacaoCompletaRequest } from '@shared/services/requests/motor-fiscal/natureza-operacao-completa.request';
import { NaturezaOperacaoIcmsSnStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-icms-sn.struct';
import { NaturezaOperacaoIcmsExcecaoStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-icms-excecao.struct';
import { NaturezaOperacaoIcmsStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-icms.struct';
import { NaturezaOperacaoIpiExcecaoStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-ipi-excecao.struct';
import { NaturezaOperacaoIpiStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-ipi.struct';
import { NaturezaOperacaoPisExcecaoStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-pis-excecao.struct';
import { NaturezaOperacaoPisStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-pis.struct';
import { NaturezaOperacaoCofinsExcecaoStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-cofins-excecao.struct';
import { NaturezaOperacaoCofinsStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-cofins.struct';
import { NaturezaOperacaoIssqnExcecaoStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-issqn-excecao.struct';
import { NaturezaOperacaoIssqnStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-issqn.struct';
import { NaturezaOperacaoIiExcecaoStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-ii-excecao.struct';
import { NaturezaOperacaoIiStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-ii.struct';
import { NaturezaOperacaoReformaTributariaStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-reforma-tributaria.struct';
import { NaturezaOperacaoTotaisStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-totais.struct';
import { FinalidadeNFeStruct } from '@shared/services/structs/motor-fiscal/finalidade-nfe.struct';
import { RegimeTributarioStruct } from '@shared/services/structs/motor-fiscal/regime-tributario.struct';
import { TipoOperacaoStruct } from '@shared/services/structs/motor-fiscal/tipo-operacao.struct';
import { CsosnStruct } from '@shared/services/structs/motor-fiscal/csosn.struct';
import { NaturezaOperacaoIcmsSnExcecaoPendenteStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-icms-sn-excecao-pendente.struct';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { CstIcmsStruct } from '@shared/services/structs/motor-fiscal/cst-icms.struct';
import { NaturezaOperacaoIcmsExcecaoPendenteStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-icms-excecao-pendente.struct';
import { NaturezaOperacaoPisExcecaoPendenteStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-pis-excecao-pendente.struct';
import { NaturezaOperacaoCofinsExcecaoPendenteStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-cofins-excecao-pendente.struct';
import { NaturezaOperacaoIpiExcecaoPendenteStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-ipi-excecao-pendente.struct';
import { NaturezaOperacaoIssqnExcecaoPendenteStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-issqn-excecao-pendente.struct';
import { CstIpiStruct } from '@shared/services/structs/motor-fiscal/cst-ipi.struct';
import { CstPisStruct } from '@shared/services/structs/motor-fiscal/cst-pis.struct';
import { CstCofinsStruct } from '@shared/services/structs/motor-fiscal/cst-cofins.struct';
import { CstIssqnStruct } from '@shared/services/structs/motor-fiscal/cst-issqn.struct';
import { LookupItemStruct } from '@shared/services/structs/motor-fiscal/lookup-item.struct';
import { ModalidadeBcOption } from '@shared/services/structs/motor-fiscal/modalidade-bc-option.struct';
import { NaturezaOperacaoIiExcecaoPendenteStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-ii-excecao-pendente.struct';
import { TipoFormulaEnum } from '@shared/enums/formula/tipo-formula.enum';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCatalogoGrupoStruct } from '@shared/services/structs/formula/formula-catalogo-grupo.struct';
import { RegraTributariaNaturezaOperacaoStruct } from '@shared/services/structs/motor-fiscal/regra-tributaria-natureza-operacao.struct';
import { HeaderComponent } from '@shared/components/header/header.component';
import { FooterActionComponent } from '@shared/components/footer-action/footer-action.component';
import { NaturezaOperacaoDadosGeraisTabComponent } from './tabs/natureza-operacao-dados-gerais-tab/natureza-operacao-dados-gerais-tab.component';
import { NaturezaOperacaoIcmsSnTabComponent } from './tabs/natureza-operacao-icmssn-tab/natureza-operacao-icmssn-tab.component';
import { NaturezaOperacaoIcmsTabComponent } from './tabs/natureza-operacao-icms-tab/natureza-operacao-icms-tab.component';
import { NaturezaOperacaoIpiTabComponent } from './tabs/natureza-operacao-ipi-tab/natureza-operacao-ipi-tab.component';
import { NaturezaOperacaoPisTabComponent } from './tabs/natureza-operacao-pis-tab/natureza-operacao-pis-tab.component';
import { NaturezaOperacaoCofinsTabComponent } from './tabs/natureza-operacao-cofins-tab/natureza-operacao-cofins-tab.component';
import { NaturezaOperacaoIssqnTabComponent } from './tabs/natureza-operacao-issqn-tab/natureza-operacao-issqn-tab.component';
import { NaturezaOperacaoIiTabComponent } from './tabs/natureza-operacao-ii-tab/natureza-operacao-ii-tab.component';
import { NaturezaOperacaoReformaTributariaTabComponent } from './tabs/natureza-operacao-reforma-tributaria-tab/natureza-operacao-reforma-tributaria-tab.component';
import { NaturezaOperacaoTotaisTabComponent } from './tabs/natureza-operacao-totais-tab/natureza-operacao-totais-tab.component';
import { TabsScrollDirective } from '@shared/directives/tabs-scroll.directive';

@Component({
    selector: 'app-natureza-operacao-cadastro',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        MatTabsModule,
        HeaderComponent,
        FooterActionComponent,
        TabsScrollDirective,
        NaturezaOperacaoDadosGeraisTabComponent,
        NaturezaOperacaoIcmsSnTabComponent,
        NaturezaOperacaoIcmsTabComponent,
        NaturezaOperacaoIpiTabComponent,
        NaturezaOperacaoPisTabComponent,
        NaturezaOperacaoCofinsTabComponent,
        NaturezaOperacaoIssqnTabComponent,
        NaturezaOperacaoIiTabComponent,
        NaturezaOperacaoReformaTributariaTabComponent,
        NaturezaOperacaoTotaisTabComponent,
    ],
    templateUrl: './natureza-operacao-cadastro.component.html',
    styleUrl: './natureza-operacao-cadastro.component.css',
})
export class NaturezaOperacaoCadastroComponent implements OnInit {
    public moduloEnum = ModuloEnum.Configuracoes;
    public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_NotasFiscais;

    public form!: FormGroup;
    public isEditMode = false;
    public idNaturezaOperacao: number | null = null;
    public isLoading = false;
    public isSaving = false;

    /** True quando há alterações não salvas (form ou exceções pendentes), para confirmar a saída. */
    public isDirty = false;
    /** Guarda o valueChanges do form: ignora o patchValue do carregamento inicial. */
    private _cargaConcluida = false;

    public finalidades: FinalidadeNFeStruct[] = [];
    public regimes: RegimeTributarioStruct[] = [];
    public tiposOperacao: TipoOperacaoStruct[] = [];
    /** Catálogo dos tipos de padrão ativos, com a natureza que hoje é o padrão de cada tipo. */
    public tiposPadrao: TipoPadraoNaturezaOperacaoStruct[] = [];
    /** Padrões gravados da natureza em edição (vazio na criação e no duplicar): marcá-los não substitui ninguém. */
    public tiposPadraoIniciais: TipoPadraoNaturezaEnum[] = [];
    /** Emissores ativos com NF-e ativa, para o campo Emissor da aba Dados Gerais. */
    public emissores: EmissorElegivelStruct[] = [];
    public csosns: CsosnStruct[] = [];
    public cstsIcms: CstIcmsStruct[] = [];
    public cstsIpi: CstIpiStruct[] = [];
    public cstsPis: CstPisStruct[] = [];
    public cstsCofins: CstCofinsStruct[] = [];
    public indicadoresIss: CstIssqnStruct[] = [];
    // Lookups do bootstrap `natureza-operacao-cadastro`, distribuídas por @Input() para as seções
    // filhas que hoje buscavam cada uma sozinha (tributo-regra-section × 6, seções da aba Totais).
    public modalidadesBc: ModalidadeBcOption[] = [];
    public modalidadesBcSt: ModalidadeBcOption[] = [];
    public motivosDesoneracaoIcms: LookupItemStruct[] = [];
    public motivosReducaoAdRem: LookupItemStruct[] = [];
    public indicadoresIncentivoFiscalIssqn: LookupItemStruct[] = [];
    public tiposBaseCalculoRetencao: LookupItemStruct[] = [];
    public indicadoresComposicaoTotalItem: LookupItemStruct[] = [];
    public indicadoresDeducaoDesoneracaoIcms: LookupItemStruct[] = [];
    public indicadoresComposicaoTotalPisSt: LookupItemStruct[] = [];
    public indicadoresComposicaoTotalCofinsSt: LookupItemStruct[] = [];
    public tiposOperacaoVeiculo: LookupItemStruct[] = [];
    public regimesEspeciaisTributacaoIssqn: LookupItemStruct[] = [];
    public formulasIcmsSn: FormulaCatalogoItemStruct[] = [];
    public formulasIcms: FormulaCatalogoItemStruct[] = [];
    public formulasIpi: FormulaCatalogoItemStruct[] = [];
    public formulasPis: FormulaCatalogoItemStruct[] = [];
    public formulasCofins: FormulaCatalogoItemStruct[] = [];
    public formulasIssqn: FormulaCatalogoItemStruct[] = [];
    public formulasIi: FormulaCatalogoItemStruct[] = [];
    public formulasTotais: FormulaCatalogoItemStruct[] = [];
    public estadosFormulasIcmsSn: FormulaItemStruct[] = [];
    public estadosFormulasIcms: FormulaItemStruct[] = [];
    public estadosFormulasIpi: FormulaItemStruct[] = [];
    public estadosFormulasPis: FormulaItemStruct[] = [];
    public estadosFormulasCofins: FormulaItemStruct[] = [];
    public estadosFormulasIssqn: FormulaItemStruct[] = [];
    public estadosFormulasIi: FormulaItemStruct[] = [];
    public estadosFormulasTotais: FormulaItemStruct[] = [];
    public _icmsSnExcecoesPendentes: NaturezaOperacaoIcmsSnExcecaoPendenteStruct[] = [];
    public _icmsExcecoesPendentes: NaturezaOperacaoIcmsExcecaoPendenteStruct[] = [];
    public _ipiExcecoesPendentes: NaturezaOperacaoIpiExcecaoPendenteStruct[] = [];
    public _pisExcecoesPendentes: NaturezaOperacaoPisExcecaoPendenteStruct[] = [];
    public _cofinsExcecoesPendentes: NaturezaOperacaoCofinsExcecaoPendenteStruct[] = [];
    public _issqnExcecoesPendentes: NaturezaOperacaoIssqnExcecaoPendenteStruct[] = [];
    public _iiExcecoesPendentes: NaturezaOperacaoIiExcecaoPendenteStruct[] = [];

    /** Carimbo de concorrência dos vínculos da linhagem carregado na tela (trava otimista). */
    private _carimboVinculos: string | null = null;

    /** Ids das configs (singleton) da versão carregada, para amarrar a origem no save incremental. */
    private _idsSingletonCarregados: {
        icms?: number | null; icmsSn?: number | null; ipi?: number | null; pis?: number | null;
        cofins?: number | null; issqn?: number | null; ii?: number | null; totais?: number | null;
    } = {};

    public selectedTabIndex = 0;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog,
        private naturezaService: NaturezaOperacaoService,
        private lookupService: MotorFiscalLookupService,
        private formulaService: FormulaCatalogoService,
        private emissorService: EmissorService,
        private alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            nome:                      ['', [Validators.required, Validators.maxLength(150)]],
            finalidadeNFe:           [FinalidadeNFeEnum.Normal],
            regimeTributario:        [null, Validators.required],
            tipoOperacao:            [TipoOperacaoEnum.Saida],
            idEmissor:                 [null],
            cfopPadrao:                [null, Validators.required],
            isAtivo:                   [true],
            // Tipos de padrão da natureza ("Padrão para"); o salvar sempre manda a lista.
            tiposPadrao:               [[] as TipoPadraoNaturezaEnum[]],
            atualizaPrecoUltimaCompra: [false],
            consideraCmvDre:           [false],
            consideraReceitaDre:       [false],
            // Rascunhos de ciclo da natureza configurados no modal do salvar (um por ciclo); vão em ciclosEmpresa.
            _ciclosEmpresa:            [[] as FormulaCicloEmpresaRascunho[]],
            icmsSn: this.fb.group({
                isAtivo:       [false],
                csosn:        [null],
                cfopPadrao:         [null],
                isDifalHabilitado:      [false],
                pCredIcmsSn:            [null],
                modalidadeBc:       [null],
                pRedBc:             [null],
                pIcms:              [null],
                modalidadeBcSt:     [null],
                pMvaStIcmsSn:           [null],
                pRedBcSt:           [null],
                pIcmsSt:            [null],
                pFcpSt:             [null],
                pSt:                [null],
                pFcpStRet:          [null],
                pRedBcEfet:         [null],
                pIcmsEfet:          [null],
                obterIcmsStCompra:  [false],
                codigoBeneficioFiscal: [null],
                observacao:         [null],
                observacaoFisco:    [null],
                _estadosFormulas:   [[]],
            }),
            icms: this.fb.group({
                isAtivo:       [false],
                cstIcms:      [null],
                cfopPadrao:         [null],
                isDifalHabilitado:      [false],
                modalidadeBc:       [null],
                pRedBc:             [null],
                pIcms:              [null],
                pFcp:               [null],
                modalidadeBcSt:     [null],
                pMvaSt:             [null],
                pRedBcSt:           [null],
                pIcmsSt:            [null],
                pFcpSt:             [null],
                motDesIcms: [null],
                motDesIcmsSt:       [null],
                codigoBeneficioFiscal: [null],
                obterIcmsStCompra:  [false],
                pDif:               [null],
                pFcpDif:            [null],
                codigoBeneficioRbc: [null],
                pRedAdRem:          [null],
                motRedAdRem:        [null],
                pSt:                [null],
                pFcpStRet:          [null],
                pRedBcEfet:         [null],
                pIcmsEfet:          [null],
                observacao:         [null],
                observacaoFisco:    [null],
                _estadosFormulas:   [[]],
            }),
            ipi: this.fb.group({
                isAtivo:       [false],
                cstIpi:        [null],
                codigoEnquadramentoIpi: [null],
                pIpi:               [null],
                vUnid:              [null],
                observacao:         [null],
                observacaoFisco:    [null],
                _estadosFormulas:   [[]],
            }),
            pis: this.fb.group({
                isAtivo:       [false],
                cstPis:        [null],
                pPis:               [null],
                vAliqProd:          [null],
                pPisSt:             [null],
                vAliqProdSt:        [null],
                geraCredito:        [false],
                observacao:         [null],
                observacaoFisco:    [null],
                isSincronizarCst:   [true],
                _estadosFormulas:   [[]],
            }),
            cofins: this.fb.group({
                isAtivo:       [false],
                cstCofins:     [null],
                isSincronizarCst:   [true],
                pCofins:            [null],
                vAliqProd:          [null],
                pCofinsSt:          [null],
                vAliqProdSt:        [null],
                geraCredito:        [false],
                observacao:         [null],
                observacaoFisco:    [null],
                _estadosFormulas:   [[]],
            }),
            issqn: this.fb.group({
                isAtivo:       [false],
                indicadorIss:  [null],
                vAliq:              [null],
                numeroProcesso:     [null],
                indIncentivo:       [null],
                observacao:         [null],
                observacaoFisco:    [null],
                _estadosFormulas:   [[]],
            }),
            ii: this.fb.group({
                isAtivo:       [false],
                pIi:                [null],
                pIof:               [null],
                fundamentoLegal:    [null],
                observacao:         [null],
                observacaoFisco:    [null],
                _estadosFormulas:   [[]],
            }),
            reformaTributaria: this.fb.group({
                isAtivo:           [false],
                idRegraTributariaPadrao:[null],
                _regraTributariaPadrao: [null],
                regrasRelacionadas: [[]],
            }),
            totais: this.fb.group({
                isAtivo:        [true],
                indTot:              ['1'],
                indDeduzDeson:       ['0'],
                indSomaPisst:        ['0'],
                indSomaCofinsst:     ['0'],
                tipoOperacaoVeiculo: [null],
                retencaoFonteAtivo:  [false],
                dataCompetenciaIssqn:[null],
                codigoRegimeTributarioIssqn: [null],
                // Controle apenas de UI: expande a seção de data de competência do ISSQN.
                _issqnOverrideAtivo: [false],
                // Retenções na fonte (persistidas em natureza_operacao_totais).
                idTipoBaseCalculoRetencao: [null],
                retencaoPis:         [null],
                retencaoCofins:      [null],
                retencaoCsll:        [null],
                irrf:                [null],
                aliquotaInss:        [null],
                baseInss:            [null],
                _estadosFormulas:    [[]],
            }),
        });

        this.form.get('tipoOperacao')!.valueChanges.subscribe(() => this.onTipoChange());
        this.form.get('regimeTributario')!.valueChanges.subscribe(() => this.onRegimeChange());
        this.form.get('isAtivo')!.valueChanges.subscribe(() => this.sincronizarAtivaEPadroes());
        this.form.get('tiposPadrao')!.valueChanges.subscribe(() => this.sincronizarAtivaEPadroes());
        this.wireSincronizacaoCstPisCofins();

        // Ignora o patchValue do carregamento inicial: só marca alteração após a carga concluir.
        this.form.valueChanges.subscribe(() => {
            if (this._cargaConcluida) this.isDirty = true;
        });

        const id = this.route.snapshot.paramMap.get('idNaturezaOperacao');
        const duplicateFrom = this.route.snapshot.queryParamMap.get('duplicateFrom');
        if (id) {
            this.isEditMode = true;
            this.idNaturezaOperacao = +id;
            // Tipo de operação e regime tributário definem toda a estrutura tributária da natureza:
            // só podem ser escolhidos na criação (para trocar, criar/duplicar uma nova natureza).
            this.form.get('tipoOperacao')!.disable({ emitEvent: false });
            this.form.get('regimeTributario')!.disable({ emitEvent: false });
        } else if (duplicateFrom) {
            this.isEditMode = false;
            this.idNaturezaOperacao = +duplicateFrom;
        }

        this.carregarDominios();
    }

    /**
     * Mantém o CST do PIS e COFINS sincronizados quando "Usar o mesmo CST para PIS e COFINS"
     * estiver ativo na regra principal (US 143174 - AC-9 e ajustes bilaterais).
     */
    private wireSincronizacaoCstPisCofins(): void {
        const pisForm = this.form.get('pis');
        const cofinsForm = this.form.get('cofins');

        const pisCst = pisForm?.get('cstPis');
        const cofinsCst = cofinsForm?.get('cstCofins');

        const pisSincronizar = pisForm?.get('isSincronizarCst');
        const cofinsSincronizar = cofinsForm?.get('isSincronizarCst');

        let isSincronizando = false;

        // Ao ativar/desativar em uma tab, reflete na outra e reavalia a sincronização
        const syncToggle = (valorNovo: boolean, source: 'pis' | 'cofins') => {
            if (isSincronizando) return;
            isSincronizando = true;
            if (source === 'pis') cofinsSincronizar?.setValue(valorNovo, { emitEvent: false });
            if (source === 'cofins') pisSincronizar?.setValue(valorNovo, { emitEvent: false });

            // Se ativou o toggle, o CST do source dita a regra, desde que ambas as tabs estejam ativas
            if (valorNovo && pisForm?.get('isAtivo')?.value && cofinsForm?.get('isAtivo')?.value) {
                if (source === 'pis') cofinsCst?.setValue(pisCst?.value);
                if (source === 'cofins') pisCst?.setValue(cofinsCst?.value);
            }
            isSincronizando = false;
        };

        pisSincronizar?.valueChanges.subscribe(val => syncToggle(val, 'pis'));
        cofinsSincronizar?.valueChanges.subscribe(val => syncToggle(val, 'cofins'));

        // Ao reativar uma tab, se o toggle geral está ligado, puxa o valor da outra tab se ela estiver ativa
        pisForm?.get('isAtivo')?.valueChanges.subscribe(ativo => {
            if (ativo && pisSincronizar?.value && cofinsForm?.get('isAtivo')?.value) {
                isSincronizando = true;
                pisCst?.setValue(cofinsCst?.value);
                isSincronizando = false;
            }
        });
        cofinsForm?.get('isAtivo')?.valueChanges.subscribe(ativo => {
            if (ativo && cofinsSincronizar?.value && pisForm?.get('isAtivo')?.value) {
                isSincronizando = true;
                cofinsCst?.setValue(pisCst?.value);
                isSincronizando = false;
            }
        });

        // Quando o CST de uma tab muda, se o toggle está ligado e a outra tab está ativa, propaga
        pisCst?.valueChanges.subscribe(val => {
            if (isSincronizando) return;
            if (pisSincronizar?.value && cofinsForm?.get('isAtivo')?.value) {
                isSincronizando = true;
                cofinsCst?.setValue(val);
                isSincronizando = false;
            }
        });

        cofinsCst?.valueChanges.subscribe(val => {
            if (isSincronizando) return;
            if (cofinsSincronizar?.value && pisForm?.get('isAtivo')?.value) {
                isSincronizando = true;
                pisCst?.setValue(val);
                isSincronizando = false;
            }
        });

        // Reforma Tributária ativa exige a regra tributária padrão vinculada: sem ela o motor
        // não tem o que aplicar, então a seção ativa ficaria configurada pela metade.
        const reformaAtivo = this.form.get('reformaTributaria.isAtivo');
        reformaAtivo?.valueChanges.subscribe(ativo => this.aplicarObrigatoriedadeRegraPadrao(!!ativo));
        this.aplicarObrigatoriedadeRegraPadrao(!!reformaAtivo?.value);
    }

    /**
     * Liga/desliga o required da regra padrão conforme o toggle da aba Reforma Tributária.
     * A aba só existe na operação de saída: na entrada o required nunca vale, senão o
     * formulário fica inválido por um campo que não tem aba onde ser preenchido.
     */
    private aplicarObrigatoriedadeRegraPadrao(ativo: boolean): void {
        const regraPadrao = this.form.get('reformaTributaria.idRegraTributariaPadrao');
        if (!regraPadrao) return;

        if (ativo && this.mostrarReforma) {
            regraPadrao.addValidators(Validators.required);
        } else {
            regraPadrao.clearValidators();
        }
        regraPadrao.updateValueAndValidity({ emitEvent: false });
    }

    private carregarDominios(): void {
        this.isLoading = true;
        forkJoin({
            bootstrap: this.lookupService.getNaturezaOperacaoCadastroLookup(),
            catalogo:  this.formulaService.getContexto('natureza-operacao'),
            // Emissores vêm da API DFe. Falhar aqui não impede editar a natureza: o campo fica
            // sem opções e, em branco, a nota usa o emissor padrão.
            // A natureza ainda não tem modelo de documento próprio; o emissor é o da NF-e.
            emissores: this.emissorService.getElegiveis(ModeloDocumentoEnum.NFe).pipe(catchError(() => of(null))),
        }).subscribe({
            next: ({ bootstrap, catalogo, emissores }) => {
                if (bootstrap.isError) {
                    this.alertService.show('Erro', bootstrap.errorDescription || 'Erro ao carregar domínios', AlertType.error);
                    this.isLoading = false;
                    this._cargaConcluida = true;
                    return;
                }
                this.finalidades   = bootstrap.finalidadesNFe;
                this.regimes       = bootstrap.regimesTributarios;
                this.tiposOperacao = bootstrap.tiposOperacao;
                this.tiposPadrao   = bootstrap.tiposPadrao ?? [];
                if (!emissores || emissores.isError) {
                    this.alertService.show('Atenção', emissores?.errorDescription || 'Não foi possível carregar os emissores.', AlertType.warning);
                }
                this.emissores = emissores && !emissores.isError ? (emissores.listaEmissorElegivel ?? []) : [];
                this.csosns        = bootstrap.csosns ?? [];
                this.cstsIcms      = bootstrap.cstsIcms ?? [];
                this.cstsIpi       = bootstrap.cstsIpi ?? [];
                this.cstsPis       = bootstrap.cstsPis ?? [];
                this.cstsCofins    = bootstrap.cstsCofins ?? [];
                this.indicadoresIss = bootstrap.indicadoresExigibilidadeIss ?? [];
                this.modalidadesBc = (bootstrap.modalidadesBc ?? []).map(x => ({ valor: x.codigo ?? '', descricao: `${x.codigo ?? ''} – ${x.descricao}` }));
                this.modalidadesBcSt = (bootstrap.modalidadesBcSt ?? []).map(x => ({ valor: x.codigo ?? '', descricao: `${x.codigo ?? ''} – ${x.descricao}` }));
                this.motivosDesoneracaoIcms = bootstrap.motivosDesoneracaoIcms ?? [];
                this.motivosReducaoAdRem = bootstrap.motivosReducaoAdRem ?? [];
                this.indicadoresIncentivoFiscalIssqn = bootstrap.indicadoresIncentivoFiscalIssqn ?? [];
                this.tiposBaseCalculoRetencao = bootstrap.tiposBaseCalculoRetencao ?? [];
                this.indicadoresComposicaoTotalItem = bootstrap.indicadoresComposicaoTotalItem ?? [];
                this.indicadoresDeducaoDesoneracaoIcms = bootstrap.indicadoresDeducaoDesoneracaoIcms ?? [];
                this.indicadoresComposicaoTotalPisSt = bootstrap.indicadoresComposicaoTotalPisSt ?? [];
                this.indicadoresComposicaoTotalCofinsSt = bootstrap.indicadoresComposicaoTotalCofinsSt ?? [];
                this.tiposOperacaoVeiculo = bootstrap.tiposOperacaoVeiculo ?? [];
                this.regimesEspeciaisTributacaoIssqn = bootstrap.regimesEspeciaisTributacaoIssqn ?? [];
                const formulasPorChave = this.criarMapaFormulasPorChave(catalogo.grupos ?? []);
                this.formulasIcmsSn = formulasPorChave['natureza-operacao.simples-nacional'] ?? [];
                this.formulasIcms = formulasPorChave['natureza-operacao.icms'] ?? [];
                this.formulasIpi = formulasPorChave['natureza-operacao.ipi'] ?? [];
                this.formulasPis = formulasPorChave['natureza-operacao.pis'] ?? [];
                this.formulasCofins = formulasPorChave['natureza-operacao.cofins'] ?? [];
                this.formulasIssqn = formulasPorChave['natureza-operacao.issqn'] ?? [];
                this.formulasIi = formulasPorChave['natureza-operacao.ii'] ?? [];
                this.formulasTotais = formulasPorChave['natureza-operacao.totais'] ?? [];


                if ((this.isEditMode || this.route.snapshot.queryParamMap.get('duplicateFrom')) && this.idNaturezaOperacao) {
                    this.carregarNatureza();
                } else {
                    this.isLoading = false;
                    this._cargaConcluida = true;
                }
            },
            error: err => {
                this.isLoading = false;
                this._cargaConcluida = true;
                this.alertService.show('Erro inesperado', err.message || 'Erro ao carregar domínios', AlertType.error);
            },
        });
    }

    private carregarNatureza(): void {
        this.naturezaService.getCompleto(this.idNaturezaOperacao!).subscribe({
            next: r => {
                this.isLoading = false;
                if (r.isError) {
                    this.alertService.show('Erro', r.errorDescription || 'Natureza não encontrada', AlertType.error);
                    this._cargaConcluida = true;
                    return;
                }
                // Duplicar nasce sem padrão: o tipo de padrão é de uma natureza só por empresa.
                this.tiposPadraoIniciais = this.route.snapshot.queryParamMap.get('duplicateFrom') ? [] : [...(r.tiposPadrao ?? [])];
                this.form.patchValue({
                    nome:                      this.route.snapshot.queryParamMap.get('duplicateFrom') ? r.nome + ' - Cópia' : r.nome,
                    finalidadeNFe:           r.finalidadeNFe,
                    regimeTributario:        r.regimeTributario,
                    tipoOperacao:            r.tipoOperacao,
                    idEmissor:                 r.idEmissor ?? null,
                    cfopPadrao:                r.cfopPadrao ?? null,
                    isAtivo:                   r.isAtivo,
                    atualizaPrecoUltimaCompra: r.atualizaPrecoUltimaCompra,
                    consideraCmvDre:           r.consideraCmvDre,
                    consideraReceitaDre:       r.consideraReceitaDre,
                    tiposPadrao:               [...this.tiposPadraoIniciais],
                });

                this._carimboVinculos = r.carimboVinculos ?? null;

                // Save incremental: guarda os ids das configs carregadas para amarrar a origem no save.
                this._idsSingletonCarregados = {
                    icms:   r.icms?.idNaturezaOperacaoIcms ?? null,
                    icmsSn: r.icmsSn?.idNaturezaOperacaoIcmsSn ?? null,
                    ipi:    r.ipi?.idNaturezaOperacaoIpi ?? null,
                    pis:    r.pis?.idNaturezaOperacaoPis ?? null,
                    cofins: r.cofins?.idNaturezaOperacaoCofins ?? null,
                    issqn:  r.issqn?.idNaturezaOperacaoIssqn ?? null,
                    ii:     r.ii?.idNaturezaOperacaoIi ?? null,
                    totais: r.totais?.idNaturezaOperacaoTotais ?? null,
                };

                if (r.icmsSn) {
                    const icmsSn = r.icmsSn;
                    this.form.get('icmsSn')!.patchValue({
                        isAtivo:      icmsSn.isAtivo,
                        csosn:       icmsSn.csosn ?? null,
                        cfopPadrao:        icmsSn.cfopPadrao ?? null,
                        isDifalHabilitado:     icmsSn.isDifalHabilitado,
                        pCredIcmsSn:           icmsSn.pCredIcmsSn ?? null,
                        modalidadeBc:      icmsSn.modalidadeBc ?? null,
                        pRedBc:            icmsSn.pRedBc ?? null,
                        pIcms:             icmsSn.pIcms ?? null,
                        modalidadeBcSt:    icmsSn.modalidadeBcSt ?? null,
                        pMvaStIcmsSn:          icmsSn.pMvaStIcmsSn ?? null,
                        pRedBcSt:          icmsSn.pRedBcSt ?? null,
                        pIcmsSt:           icmsSn.pIcmsSt ?? null,
                        pFcpSt:            icmsSn.pFcpSt ?? null,
                        pSt:               icmsSn.pSt ?? null,
                        pFcpStRet:         icmsSn.pFcpStRet ?? null,
                        pRedBcEfet:        icmsSn.pRedBcEfet ?? null,
                        pIcmsEfet:          icmsSn.pIcmsEfet ?? null,
                        obterIcmsStCompra: icmsSn.obterIcmsStCompra,
                        codigoBeneficioFiscal: icmsSn.codigoBeneficioFiscal ?? null,
                        observacao:        icmsSn.observacao ?? null,
                        observacaoFisco:   icmsSn.observacaoFisco ?? null,
                    });
                }

                if (r.icmsSn?.formulas) {
                    this.estadosFormulasIcmsSn = r.icmsSn.formulas;
                    this.form.get('icmsSn')?.get('_estadosFormulas')?.setValue(this.estadosFormulasIcmsSn);
                }

                if (r.icmsSnExcecoes) {
                    this._icmsSnExcecoesPendentes = r.icmsSnExcecoes.map(e => ({
                        idExcecao: e.idExcecao ?? null,
                        req: {
                            nome:              e.nome,
                            cfopExcecao:       e.cfopExcecao ?? null,
                            csosn:       e.csosn ?? null,
                            isDifalHabilitado:     e.isDifalHabilitado,
                            pCredIcmsSn:           e.pCredIcmsSn ?? null,
                            modalidadeBc:      e.modalidadeBc ?? null,
                            pRedBc:            e.pRedBc ?? null,
                            pIcms:             e.pIcms ?? null,
                            modalidadeBcSt:    e.modalidadeBcSt ?? null,
                            pMvaStIcmsSn:          e.pMvaStIcmsSn ?? null,
                            pRedBcSt:          e.pRedBcSt ?? null,
                            pIcmsSt:           e.pIcmsSt ?? null,
                            pFcpSt:            e.pFcpSt ?? null,
                            pSt:               e.pSt ?? null,
                            pFcpStRet:         e.pFcpStRet ?? null,
                            obterIcmsStCompra: e.obterIcmsStCompra,
                            pRedBcEfet:        e.pRedBcEfet ?? null,
                            pIcmsEfet:         e.pIcmsEfet ?? null,
                            codigoBeneficioFiscal: e.codigoBeneficioFiscal ?? null,
                            observacao:        e.observacao ?? null,
                            observacaoFisco:   e.observacaoFisco ?? null,
                            dataVigenciaInicio:    e.dataVigenciaInicio,
                            dataVigenciaFim:       e.dataVigenciaFim ?? null,
                            escopos:           e.escopos.map(s => ({
                                idExcecaoEscopo: s.idExcecaoEscopo ?? null,
                                tipoEscopo:     s.tipoEscopo,
                                valoresEscopo:  s.valoresEscopo ?? [],
                            })),
                            formulas: e.formulas
                                .filter(f => f.tipo !== TipoFormulaEnum.ModeloPadrao)
                                .map(f => ({
                                    chaveFormula:      f.chaveFormula,
                                    idFormulaPersonalizada:    f.idFormulaPersonalizada ?? null,
                                    tipo:               f.tipo,
                                    chaveFormulaModelo:       f.chaveFormulaModelo ?? null,
                                    expressao:          f.expressao ?? null,
                                    tipoArredondamento: f.tipoArredondamento ?? null,
                                    casasDecimais:       f.casasDecimais ?? null,
                                    dataVigenciaInicio:     f.dataVigenciaInicio ?? null,
                                    dataVigenciaFim:        f.dataVigenciaFim ?? null,
                                })),
                        },
                    }));
                }

                if (r.icms) {
                    const icms = r.icms;
                    this.form.get('icms')!.patchValue({
                        isAtivo:          icms.isAtivo,
                        cstIcms:         icms.cstIcms ?? null,
                        cfopPadrao:            icms.cfopPadrao ?? null,
                        isDifalHabilitado:         icms.isDifalHabilitado,
                        modalidadeBc:          icms.modalidadeBc ?? null,
                        pRedBc:                icms.pRedBc ?? null,
                        pIcms:                 icms.pIcms ?? null,
                        pFcp:                  icms.pFcp ?? null,
                        modalidadeBcSt:        icms.modalidadeBcSt ?? null,
                        pMvaSt:                icms.pMvaSt ?? null,
                        pRedBcSt:              icms.pRedBcSt ?? null,
                        pIcmsSt:               icms.pIcmsSt ?? null,
                        pFcpSt:                icms.pFcpSt ?? null,
                        motDesIcms: icms.motDesIcms ?? null,
                        motDesIcmsSt:          icms.motDesIcmsSt ?? null,
                        codigoBeneficioFiscal: icms.codigoBeneficioFiscal ?? null,
                        obterIcmsStCompra:     icms.obterIcmsStCompra,
                        pDif:                  icms.pDif ?? null,
                        pFcpDif:               icms.pFcpDif ?? null,
                        codigoBeneficioRbc:    icms.codigoBeneficioRbc ?? null,
                        pRedAdRem:             icms.pRedAdRem ?? null,
                        motRedAdRem:           icms.motRedAdRem ?? null,
                        pSt:                   icms.pSt ?? null,
                        pFcpStRet:             icms.pFcpStRet ?? null,
                        pRedBcEfet:            icms.pRedBcEfet ?? null,
                        pIcmsEfet:             icms.pIcmsEfet ?? null,
                        observacao:            icms.observacao ?? null,
                        observacaoFisco:       icms.observacaoFisco ?? null,
                    });
                }
                this.estadosFormulasIcms = r.icms?.formulas ?? [];
                this.form.get('icms')?.get('_estadosFormulas')?.setValue(this.estadosFormulasIcms);
                this._icmsExcecoesPendentes = (r.icmsExcecoes ?? []).map(e => ({
                    idExcecao: e.idExcecao ?? null,
                    req: { ...e },
                }));

                if (r.ipi) {
                    this.form.get('ipi')!.patchValue({
                        isAtivo:        r.ipi.isAtivo,
                        cstIpi:              r.ipi.cstIpi ?? null,
                        codigoEnquadramentoIpi: r.ipi.codigoEnquadramentoIpi ?? null,
                        pIpi:                r.ipi.pIpi ?? null,
                        vUnid:               r.ipi.vUnid ?? null,
                        observacao:          r.ipi.observacao ?? null,
                        observacaoFisco:     r.ipi.observacaoFisco ?? null,
                    });
                }
                this.estadosFormulasIpi = r.ipi?.formulas ?? [];
                this.form.get('ipi')?.get('_estadosFormulas')?.setValue(this.estadosFormulasIpi);
                this._ipiExcecoesPendentes = (r.ipiExcecoes ?? []).map((e: NaturezaOperacaoIpiExcecaoStruct) => ({
                    idExcecao: e.idExcecao ?? null,
                    req: { ...e },
                }));

                if (r.pis) {
                    this.form.get('pis')!.patchValue({
                        isAtivo:        r.pis.isAtivo,
                        cstPis:              r.pis.cstPis ?? null,
                        pPis:                r.pis.pPis ?? null,
                        vAliqProd:           r.pis.vAliqProd ?? null,
                        pPisSt:              r.pis.pPisSt ?? null,
                        vAliqProdSt:         r.pis.vAliqProdSt ?? null,
                        geraCredito:         r.pis.geraCredito,
                        observacao:          r.pis.observacao ?? null,
                        observacaoFisco:     r.pis.observacaoFisco ?? null,
                        isSincronizarCst:   r.cofins?.isMesmoCstPis ?? true,
                    });
                }
                this.estadosFormulasPis = r.pis?.formulas ?? [];
                this.form.get('pis')?.get('_estadosFormulas')?.setValue(this.estadosFormulasPis);
                this._pisExcecoesPendentes = (r.pisExcecoes ?? []).map((e: NaturezaOperacaoPisExcecaoStruct) => ({
                    idExcecao: e.idExcecao ?? null,
                    req: { ...e },
                }));

                if (r.cofins) {
                    this.form.get('cofins')!.patchValue({
                        isAtivo:        r.cofins.isAtivo,
                        cstCofins:           r.cofins.cstCofins ?? null,
                        isSincronizarCst:    r.cofins.isMesmoCstPis,
                        pCofins:             r.cofins.pCofins ?? null,
                        vAliqProd:           r.cofins.vAliqProd ?? null,
                        pCofinsSt:           r.cofins.pCofinsSt ?? null,
                        vAliqProdSt:         r.cofins.vAliqProdSt ?? null,
                        geraCredito:         r.cofins.geraCredito,
                        observacao:          r.cofins.observacao ?? null,
                        observacaoFisco:     r.cofins.observacaoFisco ?? null,
                    });
                }
                this.estadosFormulasCofins = r.cofins?.formulas ?? [];
                this.form.get('cofins')?.get('_estadosFormulas')?.setValue(this.estadosFormulasCofins);
                this._cofinsExcecoesPendentes = (r.cofinsExcecoes ?? []).map((e: NaturezaOperacaoCofinsExcecaoStruct) => ({
                    idExcecao: e.idExcecao ?? null,
                    req: { ...e },
                }));

                if (r.issqn) {
                    this.form.get('issqn')!.patchValue({
                        isAtivo:        r.issqn.isAtivo,
                        indicadorIss:        r.issqn.indicadorIss ?? null,
                        vAliq:               r.issqn.vAliq ?? null,
                        numeroProcesso:      r.issqn.numeroProcesso ?? null,
                        indIncentivo:        r.issqn.indIncentivo ?? null,
                        observacao:          r.issqn.observacao ?? null,
                        observacaoFisco:     r.issqn.observacaoFisco ?? null,
                    });
                }
                this.estadosFormulasIssqn = r.issqn?.formulas ?? [];
                this.form.get('issqn')?.get('_estadosFormulas')?.setValue(this.estadosFormulasIssqn);
                this._issqnExcecoesPendentes = (r.issqnExcecoes ?? []).map((e: NaturezaOperacaoIssqnExcecaoStruct) => ({
                    idExcecao: e.idExcecao ?? null,
                    req: { ...e },
                }));

                if (r.ii) {
                    this.form.get('ii')!.patchValue({
                        isAtivo:    r.ii.isAtivo,
                        pIi:             r.ii.pIi ?? null,
                        pIof:            r.ii.pIof ?? null,
                        fundamentoLegal: r.ii.fundamentoLegal ?? null,
                        observacao:      r.ii.observacao ?? null,
                        observacaoFisco: r.ii.observacaoFisco ?? null,
                    });
                }
                this.estadosFormulasIi = r.ii?.formulas ?? [];
                this.form.get('ii')?.get('_estadosFormulas')?.setValue(this.estadosFormulasIi);
                this._iiExcecoesPendentes = (r.iiExcecoes ?? []).map(e => ({
                    idExcecao: e.idExcecao ?? null,
                    req: { ...e },
                }));

                if (r.reformaTributaria) {
                    this.form.get('reformaTributaria')!.patchValue({
                        // Operação de entrada não tem aba Reforma: qualquer ativação gravada
                        // para ela é resíduo e não pode ligar a obrigatoriedade da regra padrão.
                        isAtivo:            this.mostrarReforma && r.reformaTributaria.isAtivo,
                        idRegraTributariaPadrao: r.reformaTributaria.idRegraTributariaPadrao ?? null,
                        _regraTributariaPadrao:  r.reformaTributaria.regraTributariaPadrao ?? null,
                        regrasRelacionadas:      r.reformaTributaria.regrasRelacionadas ?? [],
                    });
                }

                if (r.totais) {
                    const t = r.totais;
                    let dataCompetencia: Date | null = null;
                    if (t.dataCompetenciaIssqn) {
                        const [y, m, d] = t.dataCompetenciaIssqn.substring(0, 10).split('-').map(Number);
                        if (y && m && d) dataCompetencia = new Date(y, m - 1, d);
                    }
                    this.form.get('totais')!.patchValue({
                        isAtivo:         t.isAtivo,
                        indTot:               t.indTot,
                        indDeduzDeson:        t.indDeduzDeson,
                        indSomaPisst:         t.indSomaPisst,
                        indSomaCofinsst:      t.indSomaCofinsst,
                        tipoOperacaoVeiculo:  t.tipoOperacaoVeiculo ?? null,
                        retencaoFonteAtivo:   t.retencaoFonteAtivo,
                        idTipoBaseCalculoRetencao:  t.idTipoBaseCalculoRetencao,
                        retencaoPis:          t.retencaoPis,
                        retencaoCofins:       t.retencaoCofins,
                        retencaoCsll:         t.retencaoCsll,
                        irrf:                 t.irrf,
                        aliquotaInss:         t.aliquotaInss,
                        baseInss:             t.baseInss,
                        dataCompetenciaIssqn: dataCompetencia,
                        codigoRegimeTributarioIssqn: t.codigoRegimeTributarioIssqn ?? null,
                        _issqnOverrideAtivo:  !!dataCompetencia,
                    });
                }
                this.estadosFormulasTotais = r.totais?.formulas ?? [];
                this.form.get('totais')?.get('_estadosFormulas')?.setValue(this.estadosFormulasTotais);
                if (this.route.snapshot.queryParamMap.get('duplicateFrom')) {
                    this.idNaturezaOperacao = null;
                }
                // Só a partir daqui uma mudança no form representa edição do usuário.
                this._cargaConcluida = true;
            },
            error: err => {
                this.isLoading = false;
                this._cargaConcluida = true;
                this.alertService.show('Erro inesperado', err.message || 'Erro ao carregar natureza', AlertType.error);
            },
        });
    }

    private criarMapaFormulasPorChave(grupos: FormulaCatalogoGrupoStruct[]): Record<string, FormulaCatalogoItemStruct[]> {
        return indexarFormulasContextos(grupos);
    }

    public get regimeTributarioValue(): RegimeTributarioEnum | null {
        return this.form?.get('regimeTributario')?.value ?? null;
    }

    public get tipoOperacaoValue(): TipoOperacaoEnum | null {
        return this.form?.get('tipoOperacao')?.value ?? null;
    }

    /** SN direto: aba Simples Nacional aparece apenas no regime Simples Nacional. */
    public get isSimples(): boolean {
        return this.regimeTributarioValue === RegimeTributarioEnum.SimplesNacional;
    }

    /** ICMS: regimes SN excesso/sublimite e Normal. */
    public get mostrarIcms(): boolean {
        const r = this.regimeTributarioValue;
        return r === RegimeTributarioEnum.SimplesNacionalExcessoSublimite || r === RegimeTributarioEnum.RegimeNormal;
    }

    public get mostrarIi(): boolean {
        return this.tipoOperacaoValue === TipoOperacaoEnum.Entrada;
    }

    /** Reforma Tributária (vínculo com regra) só existe para operação de SAÍDA. */
    public get mostrarReforma(): boolean {
        return this.tipoOperacaoValue === TipoOperacaoEnum.Saida;
    }

    /** Retorna true se algum controle do subgrupo indicado está inválido. */
    public isAbaInvalida(nomeSubgrupo: string): boolean {
        return this.form.get(nomeSubgrupo)?.invalid ?? false;
    }

    /** Revalida campos que dependem do tipo de operação (ex: CFOP) em todas as abas. */
    public revalidarCamposDependentesDoTipo(): void {
        const tipo = this.tipoOperacaoValue;
        const cfopIdentificacao = this.form.get('cfopPadrao') as FormControl;
        if (cfopIdentificacao) {
            validarCfopPorTipo(cfopIdentificacao, tipo);
            cfopIdentificacao.markAsTouched();
        }
        ['icmsSn', 'icms'].forEach(grupo => {
            const cfop = this.form.get(`${grupo}.cfopPadrao`) as FormControl;
            if (cfop) {
                validarCfopPorTipo(cfop, tipo);
                cfop.markAsTouched();
            }
        });
    }

    private navegarParaPrimeiraAbaInvalida(): void {
        const identificacaoInvalida =
            this.form.get('nome')?.invalid ||
            this.form.get('regimeTributario')?.invalid;
        if (identificacaoInvalida) {
            this.selectedTabIndex = 0;
            return;
        }

        // Mesma ordem e mesmas condições (@if) das abas do template: o índice do mat-tab-group conta só as
        // abas visíveis. "Totais" fica de fora: não tem indicador de pendência (isAbaInvalida não é chamado
        // para ela no HTML).
        const abasVisiveis: string[] = [
            ...(this.isSimples ? ['icmsSn'] : []),
            ...(this.mostrarIcms ? ['icms'] : []),
            'ipi',
            'pis',
            'cofins',
            'issqn',
            ...(this.mostrarIi ? ['ii'] : []),
            ...(this.mostrarReforma ? ['reformaTributaria'] : []),
        ];

        const posicaoInvalida = abasVisiveis.findIndex(nomeSubgrupo => this.isAbaInvalida(nomeSubgrupo));
        if (posicaoInvalida >= 0) this.selectedTabIndex = posicaoInvalida + 1;
    }

    // As exceções pendentes vivem fora do form reativo (arrays do wizard), então cada alteração
    // precisa marcar isDirty manualmente para a confirmação de saída também as cobrir.

    public onIcmsSnExcecoesChange(excecoes: NaturezaOperacaoIcmsSnExcecaoPendenteStruct[]): void {
        this._icmsSnExcecoesPendentes = excecoes;
        this.isDirty = true;
    }

    public onIcmsExcecoesChange(excecoes: NaturezaOperacaoIcmsExcecaoPendenteStruct[]): void {
        this._icmsExcecoesPendentes = excecoes;
        this.isDirty = true;
    }

    public onIiExcecoesChange(excecoes: NaturezaOperacaoIiExcecaoPendenteStruct[]): void {
        this._iiExcecoesPendentes = excecoes;
        this.isDirty = true;
    }

    public onIpiExcecoesChange(excecoes: NaturezaOperacaoIpiExcecaoPendenteStruct[]): void {
        this._ipiExcecoesPendentes = excecoes;
        this.isDirty = true;
    }

    public onPisExcecoesChange(excecoes: NaturezaOperacaoPisExcecaoPendenteStruct[]): void {
        this._pisExcecoesPendentes = excecoes;
        this.isDirty = true;
    }

    public onCofinsExcecoesChange(excecoes: NaturezaOperacaoCofinsExcecaoPendenteStruct[]): void {
        this._cofinsExcecoesPendentes = excecoes;
        this.isDirty = true;
    }

    public onIssqnExcecoesChange(excecoes: NaturezaOperacaoIssqnExcecaoPendenteStruct[]): void {
        this._issqnExcecoesPendentes = excecoes;
        this.isDirty = true;
    }

    /** Formata um Date como "yyyy-MM-dd" (sem efeito de fuso) para envio à API. */
    private formatarDataIso(data: Date): string {
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const dia = String(data.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
    }

    private mapFormulaItems(estados: FormulaItemStruct[]): FormulaItemStruct[] {
        return estados
            .filter(e => e.tipo !== TipoFormulaEnum.ModeloPadrao)
            .map(e => ({
                chaveFormula: e.chaveFormula,
                idFormulaPersonalizada:    e.idFormulaPersonalizada ?? null,
                tipo:               e.tipo,
                chaveFormulaModelo:       e.chaveFormulaModelo ?? null,
                expressao:          e.expressao ?? null,
                tipoArredondamento: e.tipoArredondamento ?? null,
                casasDecimais:       e.casasDecimais ?? null,
                dataVigenciaInicio:     e.dataVigenciaInicio ?? null,
                dataVigenciaFim:        e.dataVigenciaFim ?? null,
            }));
    }

    private mapIcmsExcecoes(): NaturezaOperacaoIcmsExcecaoStruct[] {
        return this._icmsExcecoesPendentes.map(p => ({
            ...p.req,
            idExcecao: p.idExcecao ?? null,
        }));
    }

    private mapIiExcecoes(): NaturezaOperacaoIiExcecaoStruct[] {
        return this._iiExcecoesPendentes.map(p => ({
            ...p.req,
            idExcecao: p.idExcecao ?? null,
        }));
    }

    private mapIpiExcecoes(): NaturezaOperacaoIpiExcecaoStruct[] {
        return this._ipiExcecoesPendentes.map(p => ({
            ...p.req,
            idExcecao: p.idExcecao ?? null,
        }));
    }

    private mapPisExcecoes(): NaturezaOperacaoPisExcecaoStruct[] {
        return this._pisExcecoesPendentes.map(p => ({
            ...p.req,
            idExcecao: p.idExcecao ?? null,
        }));
    }

    private mapCofinsExcecoes(): NaturezaOperacaoCofinsExcecaoStruct[] {
        return this._cofinsExcecoesPendentes.map(p => ({
            ...p.req,
            idExcecao: p.idExcecao ?? null,
        }));
    }

    private mapIssqnExcecoes(): NaturezaOperacaoIssqnExcecaoStruct[] {
        return this._issqnExcecoesPendentes.map(p => ({
            ...p.req,
            idExcecao: p.idExcecao ?? null,
        }));
    }

    public salvar(): void {
        this.revalidarCamposDependentesDoTipo();
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.navegarParaPrimeiraAbaInvalida();
            this.alertService.show('Atenção', 'Preencha os campos obrigatórios antes de salvar.', AlertType.warning);
            return;
        }

        this.isSaving = true;
        // getRawValue: em edição, tipo de operação e regime tributário ficam desabilitados e
        // seriam omitidos por form.value.
        const v = this.form.getRawValue();
        const icmsSn = v.icmsSn;
        const icms = v.icms;
        const ipi = v.ipi;
        const pis = v.pis;
        const cofins = v.cofins;
        const issqn = v.issqn;
        const ii = v.ii;
        const reforma = v.reformaTributaria;
        const totais = v.totais;

        const icmsSnRequest: NaturezaOperacaoIcmsSnStruct | null = this.isSimples ? {
            idNaturezaOperacaoIcmsSn: this._idsSingletonCarregados.icmsSn ?? null,
            isAtivo:      icmsSn.isAtivo,
            csosn:       icmsSn.csosn || null,
            cfopPadrao:        icmsSn.cfopPadrao || null,
            isDifalHabilitado:     icmsSn.isDifalHabilitado,
            pCredIcmsSn:           icmsSn.pCredIcmsSn ?? null,
            modalidadeBc:      icmsSn.modalidadeBc || null,
            pRedBc:            icmsSn.pRedBc ?? null,
            pIcms:             icmsSn.pIcms ?? null,
            modalidadeBcSt:    icmsSn.modalidadeBcSt || null,
            pMvaStIcmsSn:          icmsSn.pMvaStIcmsSn ?? null,
            pRedBcSt:          icmsSn.pRedBcSt ?? null,
            pIcmsSt:           icmsSn.pIcmsSt ?? null,
            pFcpSt:            icmsSn.pFcpSt ?? null,
            pSt:               icmsSn.pSt ?? null,
            pFcpStRet:         icmsSn.pFcpStRet ?? null,
            pRedBcEfet:        icmsSn.pRedBcEfet ?? null,
            pIcmsEfet:         icmsSn.pIcmsEfet ?? null,
            obterIcmsStCompra: icmsSn.obterIcmsStCompra,
            codigoBeneficioFiscal: icmsSn.codigoBeneficioFiscal || null,
            observacao:        icmsSn.observacao || null,
            observacaoFisco:   icmsSn.observacaoFisco || null,
            formulas:          this.mapFormulaItems(icmsSn._estadosFormulas ?? []),
        } : null;

        const icmsRequest: NaturezaOperacaoIcmsStruct | null = this.mostrarIcms ? {
            idNaturezaOperacaoIcms: this._idsSingletonCarregados.icms ?? null,
            isAtivo:          icms.isAtivo,
            cfopPadrao:            icms.cfopPadrao || null,
            cstIcms:         icms.cstIcms || null,
            isDifalHabilitado:         icms.isDifalHabilitado,
            modalidadeBc:          icms.modalidadeBc || null,
            pRedBc:                icms.pRedBc ?? null,
            pIcms:                 icms.pIcms ?? null,
            pFcp:                  icms.pFcp ?? null,
            modalidadeBcSt:        icms.modalidadeBcSt || null,
            pMvaSt:                icms.pMvaSt ?? null,
            pRedBcSt:              icms.pRedBcSt ?? null,
            pIcmsSt:               icms.pIcmsSt ?? null,
            pFcpSt:                icms.pFcpSt ?? null,
            motDesIcms: icms.motDesIcms || null,
            motDesIcmsSt:          icms.motDesIcmsSt || null,
            codigoBeneficioFiscal: icms.codigoBeneficioFiscal || null,
            obterIcmsStCompra:     icms.obterIcmsStCompra,
            pDif:                  icms.pDif ?? null,
            pFcpDif:               icms.pFcpDif ?? null,
            codigoBeneficioRbc:    icms.codigoBeneficioRbc || null,
            pRedAdRem:             icms.pRedAdRem ?? null,
            motRedAdRem:           icms.motRedAdRem || null,
            pSt:                   icms.pSt ?? null,
            pFcpStRet:             icms.pFcpStRet ?? null,
            pRedBcEfet:            icms.pRedBcEfet ?? null,
            pIcmsEfet:             icms.pIcmsEfet ?? null,
            observacao:            icms.observacao || null,
            observacaoFisco:       icms.observacaoFisco || null,
            formulas:              this.mapFormulaItems(icms._estadosFormulas ?? []),
        } : null;

        const iiRequest: NaturezaOperacaoIiStruct | null = this.mostrarIi ? {
            idNaturezaOperacaoIi: this._idsSingletonCarregados.ii ?? null,
            isAtivo:    ii.isAtivo,
            pIi:             ii.pIi ?? null,
            pIof:            ii.pIof ?? null,
            fundamentoLegal: ii.fundamentoLegal || null,
            observacao:      ii.observacao || null,
            observacaoFisco: ii.observacaoFisco || null,
            formulas:        this.mapFormulaItems(ii._estadosFormulas ?? []),
        } : null;

        const ipiRequest: NaturezaOperacaoIpiStruct = {
            idNaturezaOperacaoIpi: this._idsSingletonCarregados.ipi ?? null,
            isAtivo:        ipi.isAtivo,
            cstIpi:        ipi.cstIpi || null,
            codigoEnquadramentoIpi: ipi.codigoEnquadramentoIpi || null,
            pIpi:                ipi.pIpi ?? null,
            vUnid:               ipi.vUnid ?? null,
            observacao:          ipi.observacao || null,
            observacaoFisco:     ipi.observacaoFisco || null,
            formulas:            this.mapFormulaItems(ipi._estadosFormulas ?? []),
        };

        const pisRequest: NaturezaOperacaoPisStruct = {
            idNaturezaOperacaoPis: this._idsSingletonCarregados.pis ?? null,
            isAtivo:    pis.isAtivo,
            cstPis:    pis.cstPis || null,
            pPis:            pis.pPis ?? null,
            vAliqProd:       pis.vAliqProd ?? null,
            pPisSt:          pis.pPisSt ?? null,
            vAliqProdSt:     pis.vAliqProdSt ?? null,
            geraCredito:     pis.geraCredito,
            observacao:      pis.observacao || null,
            observacaoFisco: pis.observacaoFisco || null,
            formulas:        this.mapFormulaItems(pis._estadosFormulas ?? []),
        };

        const cofinsRequest: NaturezaOperacaoCofinsStruct = {
            idNaturezaOperacaoCofins: this._idsSingletonCarregados.cofins ?? null,
            isAtivo:    cofins.isAtivo,
            cstCofins: cofins.cstCofins || null,
            isMesmoCstPis:   cofins.isSincronizarCst,
            pCofins:         cofins.pCofins ?? null,
            vAliqProd:       cofins.vAliqProd ?? null,
            pCofinsSt:       cofins.pCofinsSt ?? null,
            vAliqProdSt:     cofins.vAliqProdSt ?? null,
            geraCredito:     cofins.geraCredito,
            observacao:      cofins.observacao || null,
            observacaoFisco: cofins.observacaoFisco || null,
            formulas:        this.mapFormulaItems(cofins._estadosFormulas ?? []),
        };

        const issqnRequest: NaturezaOperacaoIssqnStruct = {
            idNaturezaOperacaoIssqn: this._idsSingletonCarregados.issqn ?? null,
            isAtivo:    issqn.isAtivo,
            indicadorIss:    issqn.indicadorIss || null,
            vAliq:           issqn.vAliq ?? null,
            numeroProcesso:  issqn.numeroProcesso || null,
            indIncentivo:    issqn.indIncentivo || null,
            observacao:      issqn.observacao || null,
            observacaoFisco: issqn.observacaoFisco || null,
            formulas:        this.mapFormulaItems(issqn._estadosFormulas ?? []),
        };

        // Aba Reforma só existe na saída: na entrada não envia o bloco, como icms/sn/ii fazem.
        const reformaRequest: NaturezaOperacaoReformaTributariaStruct | null = this.mostrarReforma ? {
            isAtivo:            reforma.isAtivo,
            idRegraTributariaPadrao: reforma.idRegraTributariaPadrao ?? null,
            regrasRelacionadas:      (reforma.regrasRelacionadas ?? []) as RegraTributariaNaturezaOperacaoStruct[],
        } : null;

        const totaisRequest: NaturezaOperacaoTotaisStruct = {
            idNaturezaOperacaoTotais: this._idsSingletonCarregados.totais ?? null,
            isAtivo:         totais.isAtivo,
            indTot:               totais.indTot,
            indDeduzDeson:        totais.indDeduzDeson,
            indSomaPisst:         totais.indSomaPisst,
            indSomaCofinsst:      totais.indSomaCofinsst,
            tipoOperacaoVeiculo:  totais.tipoOperacaoVeiculo ?? null,
            retencaoFonteAtivo:   totais.retencaoFonteAtivo,
            idTipoBaseCalculoRetencao:  totais.idTipoBaseCalculoRetencao ?? null,
            retencaoPis:          totais.retencaoPis ?? null,
            retencaoCofins:       totais.retencaoCofins ?? null,
            retencaoCsll:         totais.retencaoCsll ?? null,
            irrf:                 totais.irrf ?? null,
            aliquotaInss:         totais.aliquotaInss ?? null,
            baseInss:             totais.baseInss ?? null,
            dataCompetenciaIssqn: (totais._issqnOverrideAtivo && totais.dataCompetenciaIssqn)
                ? this.formatarDataIso(totais.dataCompetenciaIssqn)
                : null,
            codigoRegimeTributarioIssqn: totais.codigoRegimeTributarioIssqn || null,
            observacao:           null,
            observacaoFisco:      null,
            formulas:             this.mapFormulaItems(totais._estadosFormulas ?? []),
        };

        const request: NaturezaOperacaoCompletaRequest = {
            nome:                      v.nome,
            finalidadeNFe:           v.finalidadeNFe,
            tipoOperacao:            v.tipoOperacao,
            regimeTributario:        v.regimeTributario,
            idEmissor:                 v.idEmissor ?? null,
            cfopPadrao:                v.cfopPadrao || null,
            isAtivo:                   v.isAtivo,
            atualizaPrecoUltimaCompra: v.atualizaPrecoUltimaCompra,
            consideraCmvDre:           v.consideraCmvDre,
            consideraReceitaDre:       v.consideraReceitaDre,
            tiposPadrao:               v.tiposPadrao ?? [],
            icmsSn:           icmsSnRequest,
            icmsSnExcecoes: this.isSimples
                ? this._icmsSnExcecoesPendentes.map(p => ({ ...p.req, idExcecao: p.idExcecao ?? null }))
                : undefined,
            icms: icmsRequest,
            icmsExcecoes: this.mostrarIcms ? this.mapIcmsExcecoes() : undefined,
            ipi: ipiRequest,
            ipiExcecoes: this.mapIpiExcecoes(),
            pis: pisRequest,
            pisExcecoes: this.mapPisExcecoes(),
            cofins: cofinsRequest,
            cofinsExcecoes: this.mapCofinsExcecoes(),
            issqn: issqnRequest,
            issqnExcecoes: this.mapIssqnExcecoes(),
            ii: iiRequest,
            iiExcecoes: this.mostrarIi ? this.mapIiExcecoes() : undefined,
            reformaTributaria: reformaRequest,
            totais: totaisRequest,
            carimboVinculos: this._carimboVinculos,
            ciclosEmpresa: coletarCiclosEmpresa(this.form),
        };

        const obs = this.isEditMode
            ? this.naturezaService.atualizarCompleto(this.idNaturezaOperacao!, request)
            : this.naturezaService.criarCompleto(request);

        obs.subscribe({
            next: response => {
                this.isSaving = false;
                if (response.isError) {
                    this.tratarErroSalvar(response);
                    return;
                }
                if (response.conflitoVinculos === true) {
                    this.tratarConflitoVinculos(response.carimboVinculos ?? null);
                    return;
                }
                if (!this.isEditMode) {
                    this.idNaturezaOperacao = response.idNaturezaOperacao;
                    this.isEditMode = true;
                }
                this.isDirty = false;
                this.alertService.show('Sucesso', 'Natureza salva com sucesso.', AlertType.success);
                this.router.navigate(['/configuracoes/notas-fiscais/natureza-operacao']);
            },
            error: err => {
                this.isSaving = false;
                this.alertService.show('Erro inesperado', err.message || 'Erro ao salvar', AlertType.error);
            },
        });
    }

    /**
     * Erro do salvar. Referência circular ou ciclo alterado abre o modal de ciclo com o ciclo devolvido pela API;
     * ao confirmar, o rascunho é acrescentado a `_ciclosEmpresa` e o salvar é repetido, um ciclo por vez. Cancelar preserva o
     * formulário e avisa com texto fixo. Os demais códigos (ciclo ambíguo, pontos de decisão inválidos etc.) só avisam.
     */
    private tratarErroSalvar(response: NaturezaOperacaoSalvarResponse): void {
        const erros = response.erros ?? [];
        const erroCiclo = erros.find(item =>
            (item.codigo === FormulaErrorCodeEnum.ReferenciaCircular || item.codigo === FormulaErrorCodeEnum.CicloAlterado
                || item.codigo === FormulaErrorCodeEnum.CicloPontosDecisaoInvalidos)
            && item.ciclo?.membros?.length);
        if (!erroCiclo?.ciclo) {
            const mensagem = erros.map(item => item.mensagem).filter(Boolean).join('\n')
                || response.errorDescription || 'Erro ao salvar';
            this.alertService.show('Erro', mensagem, AlertType.error);
            return;
        }

        const data: FormulaCicloDialogData = {
            ciclo: erroCiclo.ciclo,
            titulo: 'Referência circular entre fórmulas',
            tipoEntidadeEdicao: TipoEntidadeFormulaEnum.NaturezaOperacao,
            idEntidadeEdicao: this.idNaturezaOperacao,
        };
        this.dialog.open(FormulaCicloDialogComponent, { width: '760px', maxWidth: '96vw', maxHeight: '92vh', data })
            .afterClosed().subscribe((rascunho: FormulaCicloDialogResult | null) => {
                if (!rascunho) {
                    this.alertService.show('Atenção', 'O salvamento foi cancelado: escolha por onde o cálculo começa para salvar.', AlertType.warning);
                    return;
                }
                registrarCicloEmpresa(this.form, rascunho);
                this.salvar();
            });
    }

    /**
     * Trava otimista (Opção 3): outro usuário alterou os vínculos da linhagem desde que a tela
     * carregou; o backend não salvou nada. Recarrega apenas a seção de regras relacionadas da aba
     * Reforma Tributária (GET dedicado), atualiza o carimbo e mantém o restante do formulário para
     * o usuário revisar e salvar de novo.
     */
    private tratarConflitoVinculos(carimboRetornado: string | null): void {
        this._carimboVinculos = carimboRetornado;
        this.alertService.show(
            'Atenção',
            'Os vínculos com regras tributárias foram alterados por outro usuário e nada foi salvo. A lista de regras relacionadas foi atualizada. Revise e salve novamente.',
            AlertType.warning,
        );

        if (!this.idNaturezaOperacao) return;

        this.naturezaService.getRegrasVinculadas(this.idNaturezaOperacao).subscribe({
            next: resp => {
                if (!resp || resp.isError) return;
                this._carimboVinculos = resp.carimboVinculos ?? this._carimboVinculos;
                this.form.get('reformaTributaria.regrasRelacionadas')?.setValue(resp.regras ?? []);
            },
        });
    }

    public cancelar(): void {
        const urlLista = '/configuracoes/notas-fiscais/natureza-operacao';
        if (!this.isDirty) {
            this.router.navigate([urlLista]);
            return;
        }
        this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Descartar alterações?',
                description: 'Há alterações não salvas nesta natureza de operação. Deseja sair mesmo assim?',
                buttonConfirm: 'Descartar',
                buttonClose: 'Voltar',
            },
        }).afterClosed().subscribe(result => {
            if (result?.confirm) this.router.navigate([urlLista]);
        });
    }

    /**
     * Natureza padrão não pode ser inativada (o toggle "Ativa" trava com "Padrão para" marcado) e natureza inativa
     * não pode ser padrão ("Padrão para" trava). Mesmas regras do servidor.
     */
    private sincronizarAtivaEPadroes(): void {
        const ativa = this.form.get('isAtivo')!;
        const padroes = this.form.get('tiposPadrao')!;
        const temPadrao = (padroes.value ?? []).length > 0;

        if (temPadrao && ativa.value === true) {
            ativa.disable({ emitEvent: false });
        } else {
            ativa.enable({ emitEvent: false });
        }

        if (ativa.value === true) {
            padroes.enable({ emitEvent: false });
        } else {
            padroes.disable({ emitEvent: false });
        }
    }

    public onRegimeChange(): void {
        this.selectedTabIndex = 0;
    }

    public onTipoChange(): void {
        // O padrão depende do tipo de operação. O tipo só muda na criação (sem padrão gravado): limpa "Padrão para".
        if (this.tiposPadraoIniciais.length === 0 && (this.form.get('tiposPadrao')?.value ?? []).length > 0) {
            this.form.get('tiposPadrao')?.setValue([]);
        }
        if (!this.mostrarIi) {
            this.selectedTabIndex = 0;
        }
        this.revalidarCamposDependentesDoTipo();
        this.aplicarObrigatoriedadeRegraPadrao(!!this.form.get('reformaTributaria.isAtivo')?.value);
    }
}
